"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDetailUpdate = void 0;
const react_1 = require("react");
const web_socket_context_1 = require("../../providers/web-socket/web-socket-context");
const event_callback_hook_1 = require("../../utils/event-callback-hook");
const detail_types_1 = require("./detail-types");
function useDetailUpdate({ enabled, source, mode, onUpdate, }) {
    var _a;
    const { subscribe, unsubscribe } = (0, react_1.useContext)(web_socket_context_1.WebsocketContext);
    const id = (_a = source.data) === null || _a === void 0 ? void 0 : _a.id;
    const reloadDetail = () => {
        if (mode === detail_types_1.DetailMode.VIEW) {
            source.refresh();
        }
    };
    const handleUpdate = (0, event_callback_hook_1.useEventCallback)(async () => {
        if (onUpdate) {
            await onUpdate({ mode, source });
        }
        else {
            reloadDetail();
        }
    });
    (0, react_1.useEffect)(() => {
        const subscription = enabled && id !== undefined
            ? subscribe(`/topic/entity/${id}/update`, handleUpdate)
            : undefined;
        return () => {
            if (subscription !== undefined) {
                unsubscribe(subscription);
            }
        };
    }, [enabled, handleUpdate, id, subscribe, unsubscribe]);
}
exports.useDetailUpdate = useDetailUpdate;
//# sourceMappingURL=detail-update-hook.js.map